"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ammPaused = exports.fillPaused = exports.exchangePaused = void 0;
const types_1 = require("../types");
function exchangePaused(state) {
    return state.exchangeStatus !== types_1.ExchangeStatus.ACTIVE;
}
exports.exchangePaused = exchangePaused;
function fillPaused(state, market) {
    return ((state.exchangeStatus & types_1.ExchangeStatus.FILL_PAUSED) ===
        types_1.ExchangeStatus.FILL_PAUSED ||
        (0, types_1.isOneOfVariant)(market.status, ['paused', 'fillPaused']));
}
exports.fillPaused = fillPaused;
function ammPaused(state, market) {
    return ((state.exchangeStatus & types_1.ExchangeStatus.AMM_PAUSED) ===
        types_1.ExchangeStatus.AMM_PAUSED ||
        (0, types_1.isOneOfVariant)(market.status, ['paused', 'ammPaused']));
}
exports.ammPaused = ammPaused;
